import { render } from "./AttachVolume.vue?vue&type=template&id=212b0334&scoped=true"
import script from "./AttachVolume.vue?vue&type=script&lang=js"
export * from "./AttachVolume.vue?vue&type=script&lang=js"

import "./AttachVolume.vue?vue&type=style&index=0&id=212b0334&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212b0334"]])

export default __exports__